export const getFileSize = (url) => {
  var fileSize = "";
  var http = new XMLHttpRequest();
  http.open("GET", url, false);

  http.send(null);

  if (http.status === 200) {
    fileSize = http.getResponseHeader("Content-Length");
  }
  return fileSize;
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const openInNewTab = (base64, filename, suffix) => {
  if (base64) {
    const blob = b64toBlob(base64);
    const blobUrl = URL.createObjectURL(blob);

    if (["pdf", "png", "jpg", "jepg", "htm", "html"].includes(suffix)) {
      window.open(blobUrl, filename, "noopener,noreferrer");
    } else {
      var downloadLink = document.createElement("a");

      downloadLink.href = blobUrl;
      downloadLink.download = filename;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
};

const b64toBlob = (b64Data) => {
  const contentType = b64Data.split(";")[0].split(":")[1];
  const byteCharacters = atob(
    b64Data.substr(`data:${contentType};base64,`.length)
  );
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const shallowEqual = (a, b) => {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;

  return aKeys.every((key) => a[key] === b[key]);
};

export const deepEqual = (a, b) => {
  if (a === b) return true;

  if (
    typeof a !== "object" ||
    typeof b !== "object" ||
    a === null ||
    b === null
  )
    return false;

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;

  for (let key of aKeys) {
    if (!deepEqual(a[key], b[key])) return false;
  }

  return true;
};

/**
 * Generates a pre-filled Google Form URL with user data
 * @param {string} formId - The Google Form ID (extract from form URL: https://docs.google.com/forms/d/e/FORM_ID/viewform)
 * @param {Object} entryIds - Object mapping field names to entry IDs (e.g., { companyName: "123456789", phone: "987654321" })
 * @param {Object} userData - User data object with fields matching entryIds keys
 * @returns {string} Pre-filled Google Form URL
 * 
 * Example:
 * const formId = "1FAIpQLSd..."; // Your form ID
 * const entryIds = {
 *   companyName: "123456789",  // Entry ID for company name field
 *   phone: "987654321",         // Entry ID for phone field
 *   email: "111222333"          // Entry ID for email field
 * };
 * const userData = {
 *   companyName: "My Company",
 *   phone: "0501234567",
 *   email: "user@example.com"
 * };
 * const url = getPrefilledGoogleFormUrl(formId, entryIds, userData);
 */
export const getPrefilledGoogleFormUrl = (formId, entryIds, userData) => {
  if (!formId || !entryIds || !userData) {
    return "";
  }

  const baseUrl = `https://docs.google.com/forms/d/e/${formId}/viewform`;
  const params = [];

  // Build query parameters for each field
  Object.keys(entryIds).forEach((key) => {
    if (userData[key] !== undefined && userData[key] !== null && userData[key] !== "") {
      const entryId = entryIds[key];
      const value = encodeURIComponent(String(userData[key]));
      params.push(`entry.${entryId}=${value}`);
    }
  });

  return params.length > 0 ? `${baseUrl}?${params.join("&")}` : baseUrl;
};
